export const LEADERBOARD_TOP_MAX_LIMIT = 10;
export const LEADERBOARD_ABOVE_MAX_LIMIT = 10;
export const LEADERBOARD_BELOW_MAX_LIMIT = 10;

export const LEADERBOARD_TOP_DEFAULT_LIMIT = 4;
export const LEADERBOARD_ABOVE_DEFAULT_LIMIT = 4;
export const LEADERBOARD_BELOW_DEFAULT_LIMIT = 4;
